export const CLAIMS = {
  ADMIN: "admin",
  MARINE: "marine",
  MARINE_DATA_SOURCE: "marine-data-source",
  ROUTING: "routing",
  NAVIGATION: "navigation",
  ALPHAFACTOR: "alphafactor",
  WAVECLIMATE: "waveclimate",
  SURVEILLANCE: "surveillance",
  LOGBOOK: "logbook",
  LIGHTNING_LIVE: "lightning-live",
  LIGHTNING_NOTIFICATIONS: "lightning-notifications",
  LIGHTNING_HISTORY: "lightning-history",
  OBSERVATION: "observation",
} as const;

export type ClaimSlug = (typeof CLAIMS)[keyof typeof CLAIMS];
